import { createSlice } from '@reduxjs/toolkit'
import { AdmLogin } from '../services/AdminUser';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const initialState = {

    errorMessage: "",
    sucessfullMessage: "",
    loader: false,
    sucessfull: false,
    isError: false,
    token: "",
    userdetail: "",
    loginSuccessfull: false
}

const AuthSlice = createSlice({
    name: "ApplicantsUser",
    initialState,
    reducers: {
        clearState: (state, action) => {
            // Object.assign(state, action.payload)
            return initialState
        },
    },
    extraReducers: {


        // this is login portion

        [AdmLogin.fulfilled]: (state, action) => {
            state.loader = false

            if (action.payload === undefined) {
                toast.error('Server down')

                // console.log('undefined')
            }

            else if (action.payload.error) {
                state.isError = true
                state.errorMessage = action.payload.error
                // toast(action.payload.error)
                // console.log("payload error", action.payload.error)
            }
            else if (action.payload.message) {
                state.loginSuccessfull = true
                state.token = action.payload.token
                state.userdetail = action.payload.adminUser
                state.sucessfullMessage = action.payload.message
                // console.log(action.payload, "this is action payload")
                // toast.success("successfull login")
            }
            else {

                toast.error('internet issue')
            }
        },

        [AdmLogin.pending]: (state) => {
            state.loader = true;
        },

    }

});



export const { clearState } = AuthSlice.actions



export default AuthSlice.reducer